import { useContext } from 'react';
import { DataContext } from '../context/DataContext';
import { GlobalStylesContext } from '../context/GlobalStylesContext';
import styled from 'styled-components';

const StyledHeader = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 50;
  background-color: ${props => props.theme.headerBg};
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-bottom: 1px solid ${props => props.theme.borderPrimary};
  transition: ${props => props.theme.transition};
`;

const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  
  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

const Logo = styled.img`
  height: 50px;
  width: auto;
  
  @media (max-width: 768px) {
    height: 40px;
  }
`;

const ThemeToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid ${props => props.theme.borderPrimary};
  background-color: ${props => props.theme.cardBg};
  color: ${props => props.theme.textSecondary};
  cursor: pointer;
  transition: ${props => props.theme.transition};
  
  &:hover {
    background-color: ${props => props.theme.bgSecondary};
  }
  
  svg {
    width: 20px;
    height: 20px;
  }
`;

const SunIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <circle cx="12" cy="12" r="5"/>
    <path d="M12 1v4m0 14v4M4.22 4.22l2.83 2.83m10.9 10.9l2.83 2.83M1 12h4m14 0h4M4.22 19.78l2.83-2.83m10.9-10.9l2.83-2.83" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round"/>
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
  </svg>
);

function TopBar() {
    const { isDark, toggleTheme, logoLightMode, logoDarkMode } = useContext(GlobalStylesContext);
    
    // Use configured logos based on theme
    const currentLogo = isDark ? logoDarkMode : logoLightMode;
    
    return (
        <StyledHeader>
            <HeaderContent>
                <LogoContainer>
                    <Logo
                        src={currentLogo}
                        alt="Survey Logo"
                        onError={(e) => {
                            // Fallback to local logo if remote fails
                            e.target.src = `${process.env.PUBLIC_URL}/logo.png`;
                        }}
                    />
                </LogoContainer>
                
                <ThemeToggleButton 
                    onClick={toggleTheme}
                    aria-label="Toggle theme"
                >
                    {isDark ? <SunIcon /> : <MoonIcon />}
                </ThemeToggleButton>
            </HeaderContent>
        </StyledHeader>
    );
}

export default TopBar;